"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Photo_1 = __importDefault(require("../Photo"));

var A = styled_components_1["default"].a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  text-decoration: none;\n"], ["\n  position: relative;\n  text-decoration: none;\n"])));

var WidgetImageAd =
/** @class */
function (_super) {
  __extends(WidgetImageAd, _super);

  function WidgetImageAd() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  WidgetImageAd.prototype.render = function () {
    var _a = this.props,
        _b = _a.data,
        target = _b.target,
        name = _b.name,
        data = _a.data,
        renderEmpty = _a.renderEmpty;

    if (!target && renderEmpty) {
      return renderEmpty(data.type);
    }

    return react_1["default"].createElement(A, {
      title: name || null,
      href: target
    }, react_1["default"].createElement(Photo_1["default"], {
      data: data.media_url ? {
        picture: data
      } : data
    }));
  };

  return WidgetImageAd;
}(react_1.PureComponent);

WidgetImageAd.propTypes = {
  data: prop_types_1["default"].shape({
    uri: prop_types_1["default"].string,
    target: prop_types_1["default"].string,
    description: prop_types_1["default"].string,
    name: prop_types_1["default"].string,
    dimensions: prop_types_1["default"].shape({
      W: prop_types_1["default"].number,
      H: prop_types_1["default"].number,
      X: prop_types_1["default"].number,
      Y: prop_types_1["default"].number
    })
  }).isRequired,
  renderEmpty: prop_types_1["default"].func.isRequired
};
exports["default"] = WidgetImageAd;
var templateObject_1;